const pm = {
  // ==================== PLANT MAINTENANCE (Platzhalter / Modul-Kachel) ====================
  'pm.title': 'Plant Maintenance',
  'pm.subtitle': 'Instandhaltungsaufträge, Wartungspläne und technische Objekte verwalten',

  // ==================== PLANT-MAINTENANCE-MODUL (portiert aus i18n/*.json, Praefix pm.) ====================
  'pm.common.loading': 'Lädt…',
  'pm.common.back': 'Zurück',
  'pm.common.next': 'Weiter',
  'pm.common.done': 'Fertig',
  'pm.common.clear': 'Leeren',
  'pm.common.loadError': 'Daten konnten nicht geladen werden.',
  'pm.scope.placeholder': 'Verbindung zum Server fehlgeschlagen — Ihre zugewiesenen Werke konnten nicht geladen werden; bis dahin ist kein Anlegen oder Ändern möglich.',
  'pm.common.retry': 'Erneut versuchen',
  'pm.header.reset': 'Daten zurücksetzen',
  'pm.header.resetConfirm': 'Alle im Test angelegten Daten löschen und auf den Ausgangsstand zurücksetzen?',
  'pm.role.mechanic': 'Mechaniker',
  'pm.role.supervisor': 'Meister',
  'pm.role.controller': 'Controlling',
  'pm.search.placeholder': 'z. B. Pumpe, 10004711…',
  'pm.home.title': 'Was suchen Sie?',
  'pm.home.subtitle': 'Gerät, Auftrag oder Material — einfach tippen.',
  'pm.home.actions': 'Aktionen',
  'pm.recent.title': 'Zuletzt verwendet',
  'pm.home.soon': 'bald',
  'pm.home.notActive': '„{label}“ ist in diesem Prototyp noch nicht aktiv.',
  'pm.home.resetDone': 'Demo-Daten zurückgesetzt.',
  'pm.action.create-order.label': 'Auftrag anlegen',
  'pm.action.create-order.sub': 'In 3 Schritten',
  'pm.action.create-notification.label': 'Meldung erfassen',
  'pm.action.create-notification.sub': 'Problem + Foto',
  'pm.action.my-orders.label': 'Meine Aufträge',
  'pm.action.my-orders.sub': 'Liste & Rückmeldung',
  'pm.action.material-search.label': 'Material finden',
  'pm.action.material-search.sub': 'Visuelle Suche',
  'pm.action.backlog.label': 'Auftragsbestand',
  'pm.action.backlog.sub': 'Offene Aufträge',
  'pm.action.approvals.label': 'Freigaben',
  'pm.action.approvals.sub': 'Prüfen & freigeben',
  'pm.order.steps.device': 'Gerät',
  'pm.order.steps.problem': 'Problem',
  'pm.order.steps.confirm': 'Bestätigen',
  'pm.order.whichDevice': 'Welches Gerät?',
  'pm.order.problemLabel': 'Was ist das Problem?',
  'pm.order.problemPlaceholder': 'Kurz beschreiben…',
  'pm.order.pastNotifications': 'Frühere Meldungen an diesem Gerät:',
  'pm.order.priority': 'Priorität',
  'pm.order.confirmTitle': 'Auftrag bestätigen',
  'pm.order.fieldDevice': 'Gerät',
  'pm.order.fieldProblem': 'Problem',
  'pm.order.fieldPriority': 'Priorität',
  'pm.order.fieldOrderType': 'Auftragsart',
  'pm.order.fieldPlant': 'Werk',
  'pm.order.fieldWorkCenter': 'Arbeitsplatz',
  'pm.order.longTextLabel': 'Details (optional)',
  'pm.order.longTextPlaceholder': 'Ausführliche Beschreibung — Diktat landet hier, ohne Zeichenbegrenzung.',
  'pm.order.fieldLongText': 'Details',
  'pm.order.detailsShow': 'Details ändern',
  'pm.order.detailsHide': 'Details ausblenden',
  'pm.order.defaultsNote': 'Vorbelegt aus Ihrem Profil. (Bearbeitung im Prototyp eingeschränkt.)',
  'pm.order.createBtn': 'Auftrag anlegen',
  'pm.order.creating': 'Wird angelegt…',
  'pm.order.createHint': 'Wird direkt in SAP angelegt',
  'pm.order.createHintMock': 'Demo-Modus — es wird nichts nach SAP geschrieben',
  'pm.order.successTitle': 'Auftrag angelegt',
  'pm.order.orderNumber': 'Auftragsnummer',
  'pm.order.duplicateNote': '(bereits vorhanden — kein Duplikat erstellt)',
  'pm.order.addPartsNow': 'Auftrag öffnen & Teile hinzufügen',
  'pm.order.openCreated': 'Auftrag öffnen',
  'pm.order.errorPrefix': 'Fehler',
  'pm.priority.low': 'Niedrig',
  'pm.priority.mid': 'Mittel',
  'pm.priority.high': 'Hoch',
  'pm.priority.veryHigh': 'Sehr hoch (Anlage steht)',
  // Auftragsart-Codes -> Absicht (Demo-Customizing; je Kunde aus sap-contract-requirements.md §6a).
  'pm.orderType.PM02': 'Wartung',
  'pm.orderType.PM03': 'Reparatur',
  // SAP-Transparenz-Panel (SapPayloadPanel): Felder, die an SAP gehen bzw. aus SAP kamen.
  'pm.sap.show': 'SAP-Felder anzeigen',
  'pm.sap.hide': 'SAP-Felder ausblenden',
  'pm.sap.toSapNote': 'Diese Felder werden an SAP übertragen.',
  'pm.sap.fromSapNote': 'Diese Felder kamen so aus SAP.',
  'pm.sap.fromSapNoteMock': 'Demo-Daten — diese Felder kommen aus dem Mock-Adapter, nicht aus SAP.',
  'pm.sap.plannedStart': 'Geplanter Start',
  'pm.sap.plannedEnd': 'Geplantes Ende',
  // Feld, das das Portal erfasst, das der Adapter aber nie auf die Leitung legt
  // (PM-SAP-FIELD-TRANSPARENCY §1.1): das Panel hat solche Felder bisher als übertragen gelistet.
  'pm.sap.notSent': 'geht nicht an SAP',
  'pm.sap.notSentNote': 'Ausgegraute Felder bleiben im Portal — sie werden hier festgehalten, aber nicht an SAP übertragen.',
  'pm.status.CRTD': 'Angelegt',
  'pm.status.REL': 'Freigegeben',
  'pm.status.CNF': 'Rückgemeldet',
  'pm.status.TECO': 'Abgeschlossen',
  'pm.status.CLSD': 'Abgeschlossen (kaufm.)',
  'pm.status.PCNF': 'Teilrückgemeldet',
  // (i)-Feld-Erklaerungen: Zweck, Wertebedeutung, Wahl-Hilfe (ui.js Row / SapPayloadPanel)
  'pm.info.orderType': 'Steuert, wie SAP den Auftrag behandelt (Nummernkreis, Kalkulation, Berechtigungen). Wartung = geplante Instandhaltung, Reparatur = Störung beheben. Im Zweifel: Reparatur.',
  'pm.info.plant': 'Das Werk, in dem instand gehalten wird. Bestimmt Lagerbestände, Arbeitsplätze und Kostenrechnung. Kommt aus Ihrem Profil-Scope.',
  'pm.info.workCenter': 'Wer die Arbeit ausführt (Team/Gewerk). Steuert die Plankosten (Stundensatz) und wessen „Meine Aufträge“-Liste den Auftrag zeigt.',
  'pm.info.equipment': 'Das technische Objekt, an dem gearbeitet wird. Über die Nummer sammelt SAP die komplette Historie (frühere Meldungen, Kosten) dieses Geräts.',
  'pm.info.priority': 'Dringlichkeit 1 (sehr hoch) bis 4 (niedrig). Beeinflusst die Terminierung: hohe Priorität = frühere Ecktermine. Hoch nur bei Stillstand oder Sicherheitsrisiko wählen.',
  'pm.info.problem': 'Der Kurztext des Auftrags (max. 40 Zeichen in SAP). Erscheint in allen Listen — so konkret wie möglich: „Pumpe P01 läuft unrund“ statt „defekt“.',
  'pm.info.status': 'SAP-Systemstatus: CRTD angelegt → REL freigegeben (Arbeit kann starten) → CNF rückgemeldet → TECO technisch fertig → CLSD kaufmännisch abgeschlossen (keine Buchungen mehr).',
  'pm.info.plannedDates': 'Geplanter Ausführungszeitraum. Von der SAP-Terminierung aus Ecktermin + Priorität berechnet; maßgeblich für Überfällig-Anzeigen.',
  'pm.info.maintenancePlan': 'Dieser Auftrag wurde automatisch von einem Wartungsplan erzeugt (vorbeugende Instandhaltung) — Termin und Inhalt kommen aus dem Plan, nicht von einer Person.',
  'pm.info.notification': 'Die zum Auftrag gehörende Meldung (Störmeldung). Trägt die Schadensdokumentation; bei diesem Auftragstyp legt SAP sie automatisch mit an.',
  // Vorlagen (Slice a)
  'pm.tpl.title': 'Vorlagen',
  'pm.tpl.sharedTag': '(geteilt)',
  'pm.tpl.namePlaceholder': 'Als Vorlage speichern: Name…',
  'pm.tpl.saveBtn': 'Vorlage speichern',
  'pm.tpl.saving': 'Speichert…',
  'pm.tpl.saved': 'Vorlage gespeichert — beim nächsten Auftrag ein Tipp in Schritt 1.',
  'pm.tpl.saveError': 'Vorlage konnte nicht gespeichert werden.',
  'pm.tpl.shareLabel': 'Für alle Nutzer freigeben (geteilte Vorlage)',
  // Vorbeugende Instandhaltung
  'pm.badge.preventive': 'Wartungsplan',
  'pm.detail.maintenancePlan': 'Wartungsplan',
  'pm.detail.notification': 'Meldung',
  'pm.dash.show': 'Dashboard einblenden',
  'pm.dash.hide': 'Dashboard ausblenden',
  'pm.dash.pendingApprovals': 'Wartende Freigaben',
  'pm.dash.openOrders': 'Offene Aufträge',
  'pm.dash.overdue': 'Überfällig',
  'pm.dash.openNotifications': 'Offene Meldungen',
  'pm.dash.byStatus': 'Nach Status',
  'pm.dash.byType': 'Nach Auftragsart',
  'pm.dash.recentNotifications': 'Neueste Meldungen',
  'pm.dash.empty': 'Keine Daten.',
  'pm.dash.mockBadge': 'Mock-Daten',
  'pm.dash.clickHint': 'Klicken für Liste',
  'pm.week.next7': 'Nächste 7 Tage',
  'pm.week.my': 'Meine Woche',
  'pm.week.overdue': 'Überfällig',
  'pm.week.today': 'Heute',
  'pm.week.unscheduled': 'ohne Termin',
  'pm.orders.myTitle': 'Meine Aufträge',
  'pm.orders.backlogTitle': 'Auftragsbestand',
  'pm.orders.approvalsTitle': 'Freigaben',
  'pm.orders.approvalsHint': 'Aufträge im Status „Angelegt“ — prüfen und freigeben.',
  'pm.orders.empty': 'Keine Aufträge gefunden.',
  'pm.orders.countSuffix': 'Aufträge',
  'pm.orders.truncated': 'Es werden nur die neuesten Aufträge angezeigt — SAP hat die maximale Zeilenzahl geliefert. Auf Werk oder Arbeitsplatz einschränken, um die übrigen zu sehen.',
  'pm.orders.countOne': 'Auftrag',
  'pm.detail.title': 'Auftrag',
  // Bezeichnung für die rohe SAP-Statuszeile (statusDetail — „REL PCNF MANC NMAT“), die der
  // Adapter bei jedem Lesen liefert und die kein Screen zeigte (PM-SAP-FIELD-TRANSPARENCY §6.3).
  'pm.detail.sapStatus': 'SAP-Status',
  'pm.detail.operations': 'Arbeitsgänge',
  // Rueckmelde-Panel: was tatsaechlich gebucht wurde, plus Storno (SAP loescht nie - es bucht
  // eine Storno-Rueckmeldung, beide Zeilen bleiben sichtbar).
  'pm.conf.title': 'Gebuchte Zeiten',
  'pm.conf.none': 'Auf diesem Auftrag ist noch nichts gebucht.',
  'pm.conf.reverse': 'Stornieren',
  'pm.conf.reversing': 'Storniere…',
  'pm.conf.reversed': 'storniert',
  'pm.conf.isReversal': 'Storno',
  'pm.conf.reverseFailed': 'SAP hat die Stornierung abgelehnt.',
  'pm.detail.components': 'Komponenten',
  'pm.detail.confirmedShort': 'rückgemeldet',
  'pm.detail.hours': 'Stunden',
  'pm.detail.finalConfirmation': 'Endrückmeldung (Arbeitsgang abschließen)',
  'pm.detail.confirmSubmit': 'Zeit rückmelden',
  'pm.detail.confirming': 'Wird gebucht…',
  'pm.detail.confirmPosted': 'Rückmeldung gebucht',
  'pm.detail.confirmReplayed': 'bereits gebucht — kein Duplikat',
  'pm.detail.release': 'Auftrag freigeben',
  'pm.detail.releasing': 'Wird freigegeben…',
  'pm.detail.releasedNote': 'Auftrag freigegeben — Arbeit kann beginnen.',
  'pm.detail.teco': 'Technisch abschließen',
  'pm.detail.tecoing': 'Wird abgeschlossen…',
  'pm.detail.tecoNote': 'Auftrag technisch abgeschlossen — die Arbeit ist erledigt.',
  'pm.detail.close': 'Kaufmännisch abschließen',
  'pm.detail.closing': 'Wird abgeschlossen…',
  'pm.detail.closedNote': 'Auftrag kaufmännisch abgeschlossen — es sind keine Buchungen mehr möglich.',
  'pm.detail.closeHint': 'Letzter Schritt: nach dem kaufmännischen Abschluss kann auf diesen Auftrag nichts mehr gebucht werden.',
  'pm.detail.qty': 'Menge',
  'pm.detail.notFound': 'Auftrag nicht gefunden.',
  // Komponenten uebergeben (SAP erzeugt Reservierung/BANF selbst)
  'pm.comp.add': 'Komponente hinzufügen',
  'pm.comp.addBtn': 'An SAP übergeben',
  'pm.comp.adding': 'Wird übergeben…',
  'pm.comp.stockAtPlant': 'Verfügbar im Werk',
  'pm.comp.shortfallHint': 'Bei Unterdeckung erzeugt SAP automatisch eine Bestellanforderung (BANF).',
  'pm.comp.resShort': 'Res.',
  'pm.comp.prShort': 'BANF',
  'pm.materials.title': 'Material finden',
  'pm.materials.subtitle': 'Beschreibung, Nummer oder Merkmal — z. B. „Lager“ oder „45 mm“.',
  'pm.materials.placeholder': 'z. B. Lager, Dichtung, 9000012352…',
  'pm.materials.available': 'verfügbar',
  'pm.materials.bin': 'Lagerplatz',
  'pm.materials.outOfStock': 'Nicht auf Lager',
  'pm.materials.noResults': 'Keine Treffer.',
  'pm.materials.loadingStock': 'Bestand wird geladen…',
  // Spracheingabe (Tier 1, hinter unternehmensweitem Flag pm_features.voice)
  'pm.voice.loading': 'Spracheingabe wird geladen …',
  'pm.voice.externalAiOff': 'Spracheingabe ist in dieser Instanz nicht verfügbar: externe KI ist nicht freigegeben.',
  'pm.voice.disabledMsg': 'Spracheingabe ist unternehmensweit deaktiviert. Das Browser-Diktat sendet Audio an den Browser-Hersteller (Google/Microsoft/Apple) — die Freigabe muss unternehmensweit bestätigt werden, oder es wird ein lokales Sprachmodell auf eigenen Servern eingerichtet.',
  'pm.voice.unsupported': 'Dieser Browser unterstützt keine Spracherkennung (z. B. Firefox). Bitte Chrome, Edge oder Safari verwenden.',
  'pm.voice.start': 'Diktat starten (Push-to-talk)',
  'pm.voice.stop': 'Diktat stoppen',
  'pm.voice.listening': 'Höre zu',
  'pm.voice.transcribing': 'Wird transkribiert…',
  'pm.voice.serverError': 'Lokales Sprachmodell nicht erreichbar. Bitte Administrator informieren (Server prüfen / Verbindungstest erneut ausführen).',
  'pm.voice.micDenied': 'Mikrofonzugriff wurde verweigert — bitte in den Browser-Einstellungen (bzw. Unternehmens-Policy) erlauben.',
  'pm.voice.noMic': 'Kein Mikrofon gefunden. Bitte Mikrofon anschließen und prüfen, ob Windows den Mikrofonzugriff für Apps erlaubt (Einstellungen → Datenschutz → Mikrofon).',
  'pm.voice.insecure': 'Mikrofonzugriff ist nur über localhost oder HTTPS möglich — bitte die Anwendung über eine sichere Adresse öffnen.',
  'pm.voice.micError': 'Mikrofon konnte nicht gestartet werden.',
  'pm.notif.confirmTitle': 'Meldung bestätigen',
  'pm.notif.fieldType': 'Meldungsart',
  'pm.notif.photoHint': 'Foto hinzufügen — im Prototyp noch nicht aktiv',
  'pm.notif.createBtn': 'Meldung anlegen',
  'pm.notif.creating': 'Wird angelegt…',
  'pm.notif.successTitle': 'Meldung angelegt',
  'pm.notif.notifNumber': 'Meldungsnummer',
  'pm.notif.createHint': 'Wird direkt in SAP angelegt',

  // ── Prozess-Ausbau 2026-08-09 ──
  'pm.action.notifications.label': 'Störmeldungen',
  'pm.action.notifications.sub': 'Meldungen verfolgen und bearbeiten',
  'pm.action.preventive.label': 'Vorbeugende Wartung',
  'pm.action.preventive.sub': 'Arbeitspläne, Wartungspläne, Terminierung',

  'pm.status.OSNO': 'Offen',
  'pm.status.NOPR': 'In Bearbeitung',
  'pm.status.NOCO': 'Abgeschlossen',

  'pm.notif.title': 'Störmeldungen',
  'pm.notif.empty': 'Keine Meldungen für dieses Werk.',
  'pm.notif.equipment': 'Equipment',
  'pm.notif.number': 'Meldungsnummer',
  'pm.notif.priority': 'Priorität',
  'pm.notif.plant': 'Werk',
  'pm.notif.createdAt': 'Gemeldet am',
  'pm.notif.order': 'Auftrag',
  'pm.notif.startWork': 'Bearbeitung starten',
  'pm.notif.convertTitle': 'Auftrag zu dieser Meldung anlegen',
  'pm.notif.convert': 'Auftrag anlegen',
  'pm.notif.close': 'Meldung abschließen',
  'pm.notif.notFound': 'Meldung nicht gefunden.',
  'pm.notif.actionFailed': 'SAP hat die Aktion abgelehnt.',

  'pm.prev.title': 'Vorbeugende Wartung',
  'pm.prev.tabPlans': 'Wartungspläne',
  'pm.prev.tabTaskLists': 'Arbeitspläne',
  'pm.prev.tabEquipment': 'Equipment',
  'pm.prev.newPlan': 'Neuer Wartungsplan',
  'pm.prev.planDescription': 'Was wird gewartet? (z. B. Wöchentliche Pumpenprüfung)',
  'pm.prev.cycleDays': 'Zyklus (Tage)',
  'pm.prev.equipmentOptional': 'Equipment (optional)',
  'pm.prev.createPlan': 'In SAP anlegen und terminieren',
  'pm.prev.noPlans': 'Noch keine Wartungspläne für dieses Werk.',
  'pm.prev.plan': 'Plan',
  'pm.prev.everyNDays': 'alle {n} Tage',
  'pm.prev.calls': 'Abrufe',
  'pm.prev.cycle': 'Zyklus',
  'pm.prev.startDate': 'Startdatum',
  'pm.prev.recentCalls': 'Letzte Abrufe',
  'pm.prev.order': 'Auftrag',
  'pm.prev.noOrderYet': 'noch kein Auftrag',
  'pm.prev.scheduleNow': 'Jetzt terminieren',
  'pm.prev.activate': 'Aktivieren',
  'pm.prev.deactivate': 'Deaktivieren',
  'pm.prev.actionFailed': 'SAP hat die Aktion abgelehnt.',
  'pm.prev.newTaskList': 'Neuer Arbeitsplan',
  'pm.prev.taskListDescription': 'Was wird gemacht? (z. B. Monatliche Filterprüfung)',
  'pm.prev.validFromHint': 'Gültig ab — muss AM ODER VOR dem Plan-Startdatum liegen',
  'pm.prev.startDateHint': 'Startdatum leer lassen = heute. Ein Datum in der Vergangenheit erzeugt beim Terminieren sofort alle überfälligen Aufträge — praktisch für Demos, in Produktion bewusst einsetzen.',
  'pm.prev.validFrom': 'gültig ab',
  'pm.prev.operation': 'Arbeitsschritt',
  'pm.prev.addOperation': '+ Arbeitsschritt hinzufügen',
  'pm.prev.createTaskList': 'Arbeitsplan in SAP anlegen',
  'pm.prev.noTaskLists': 'Noch keine Arbeitspläne für dieses Werk.',
  'pm.prev.noTaskListApi': 'Dieses SAP-Release hat keine Arbeitsplan-API — Arbeitspläne in SAP anlegen (IA05).',
  'pm.prev.group': 'Gruppe',

  'pm.equip.newTitle': 'Neues Equipment',
  'pm.equip.description': 'Bezeichnung (z. B. Pumpe P-100)',
  'pm.equip.costCenter': 'Kostenstelle',
  'pm.equip.plannerGroup': 'Planergruppe',
  'pm.equip.costCenterHint': 'Ohne Kostenstelle können Aufträge auf diesem Equipment später nicht technisch abgeschlossen werden (SAP IW177).',
  'pm.equip.create': 'In SAP anlegen',
  'pm.equip.createFailed': 'SAP hat das Equipment abgelehnt.',
  'pm.equip.createdAs': 'Angelegt als',
  'pm.equip.noCostCenterWarn': 'OHNE Kostenstelle angelegt — vor dem Abschluss von Aufträgen ergänzen.',
  'pm.equip.readingsTitle': 'Zähler- / Messwerte',
  'pm.equip.searchPlaceholder': 'Equipment suchen…',
  'pm.equip.noPoints': 'Dieses Equipment hat keine Messpunkte.',
  'pm.equip.counter': 'Zähler',
  'pm.equip.readingValue': 'Messwert',
  'pm.equip.recordReading': 'Messwert erfassen',
  'pm.equip.readingFailed': 'SAP hat den Messwert abgelehnt.',
  'pm.equip.readingSaved': 'Messwert gespeichert (Beleg {id}).',

  'pm.prev.tabCounters': 'Zähler',
  'pm.cnt.title': 'Zählerbasierte Wartung',
  'pm.cnt.intro': 'Objekt suchen, Zählerstände sehen, den heutigen Stand buchen und ablesen, wie weit es bis zur nächsten Wartung ist.',
  'pm.cnt.unsupported': 'Dieses SAP-System trägt den Zähler-Adapter nicht — Zähler, Ableseverlauf und leistungsabhängige Pläne stehen hier nicht zur Verfügung.',
  'pm.cnt.noCounters': 'Dieses Objekt hat keine Zähler.',
  'pm.cnt.point': 'Messpunkt',
  'pm.cnt.perYear': '{v} {u}/Jahr',
  'pm.cnt.planCount': '{n} Plan/Pläne',
  'pm.cnt.noPlans': 'kein Plan',
  'pm.cnt.recordTitle': 'Zählerstand erfassen {unit}',
  'pm.cnt.totalValue': 'Neuer Zählerstand',
  'pm.cnt.deltaValue': 'Wert seit der letzten Ablesung',
  'pm.cnt.isDifference': 'Das ist die Menge seit der letzten Ablesung, nicht der neue Gesamtstand',
  'pm.cnt.reader': 'Abgelesen von (Name)',
  'pm.cnt.dateHint': 'Das Datum der ABLESUNG — nicht der Eingabe. Ein falsches Datum verschiebt die gesamte Fälligkeitsprognose.',
  'pm.cnt.readingText': 'Notiz (optional)',
  'pm.cnt.readingFailed': 'SAP hat den Messwert abgelehnt.',
  'pm.cnt.readingSaved': 'Messwert gespeichert (Beleg {id}).',
  'pm.cnt.cancel': 'Diese Ablesung stornieren',
  'pm.cnt.cancelFailed': 'SAP hat die Stornierung abgelehnt.',
  'pm.cnt.cancelled': 'Ablesung {id} storniert.',
  'pm.cnt.alreadyCancelled': 'Diese Ablesung war bereits storniert.',
  'pm.cnt.historyTitle': 'Ableseverlauf',
  'pm.cnt.noReadings': 'Noch keine Ablesungen erfasst.',
  'pm.cnt.generated': 'automatisch erzeugt',
  'pm.cnt.historyHint': 'Stornierte Ablesungen bleiben durchgestrichen sichtbar — SAP behält sie für die Nachvollziehbarkeit.',
  'pm.cnt.dueTitle': 'Nächste Wartung',
  'pm.cnt.cycle': 'Zyklus',
  'pm.cnt.nextDueReading': 'Fällig bei',
  'pm.cnt.remaining': 'Verbleibend',
  'pm.cnt.forecast': 'Erwartet (Prognose)',
  'pm.cnt.sapScheduled': 'Von SAP terminiert',
  'pm.cnt.notScheduledYet': 'Dieser Plan wurde noch nie terminiert — noch kein SAP-Datum, nur die Prognose.',
  'pm.cnt.forecastHint': 'Die Prognose stammt aus der Jahresschätzung des Zählers. Das SAP-Datum erscheint, sobald der Plan terminiert ist.',

  'pm.costs.title': 'Kosten',
  'pm.costs.planned': 'Geplant',
  'pm.costs.actual': 'Ist',
  'pm.costs.empty': 'Noch keine Kosten gebucht.',

  'pm.gi.title': 'Ersatzteil entnehmen (Warenausgabe)',
  'pm.gi.fromComponents': 'Aus geplanten Komponenten:',
  'pm.gi.material': 'Materialnummer',
  'pm.gi.storageLocation': 'Lagerort',
  'pm.gi.post': 'Warenausgang buchen',
  'pm.gi.failed': 'SAP hat den Warenausgang abgelehnt.',
  'pm.gi.posted': 'Gebucht (Materialbeleg {doc}).',
  'pm.gi.hint': 'Die Buchung wirkt sofort: der Bestand am Lagerort sinkt und der Teilewert landet als Ist-Kosten auf diesem Auftrag.',

  // (i)-Felderklärungen für die Prozess-Ausbau-Screens
  'pm.info.notifNumber': 'Die Nummer, die SAP dieser Meldung vergeben hat. Nützlich im Gespräch mit Kollegen, die direkt in SAP arbeiten (IW22/IW29).',
  'pm.info.notifOrder': 'Der zu dieser Meldung angelegte Instandhaltungsauftrag. Die Meldung wird getrennt vom Auftrag abgeschlossen — üblicherweise nach getaner Arbeit.',
  'pm.info.cycle': 'Wie oft SAP die Arbeit einplant. Jeder Fälligkeitstermin wird ein „Abruf", und jeder Abruf wird an seinem Abruftermin ein Auftrag.',
  'pm.info.planStart': 'Das Datum, ab dem die Terminierung rechnet. Ein Start in der Vergangenheit macht alle überfälligen Zyklen auf einmal fällig — diese Aufträge legt SAP beim nächsten Terminierungslauf sofort an.',
  'pm.info.costsPlanned': 'Was die Arbeit kosten soll, aus geplanten Stunden und geplanten Teilen — von SAP beim Anlegen/Ändern des Auftrags kalkuliert.',
  'pm.info.costsActual': 'Was bisher wirklich gebucht wurde: rückgemeldete Stunden und entnommene Teile. Wächst mit jeder Rückmeldung und Warenausgabe; endgültig nach dem kaufmännischen Abschluss.',

  // ── Berichte (R1-R6) ──
  'pm.action.reports.label': 'Berichte',
  'pm.action.reports.sub': 'Kosten, Ausfälle, Termintreue',
  'pm.rep.title': 'Berichte',
  'pm.rep.tabCosts': 'Kosten',
  'pm.rep.tabBreakdowns': 'Ausfälle',
  'pm.rep.tabCompliance': 'Vorbeugend',
  'pm.rep.tabHours': 'Stunden',
  'pm.rep.tabParts': 'Teile',
  'pm.rep.tabEquipment': 'Geräteakte',
  'pm.rep.exportCsv': 'CSV',
  'pm.rep.planTotal': 'Geplant',
  'pm.rep.actualTotal': 'Ist',
  'pm.rep.corrective': 'Störungsbedingt (Ist)',
  'pm.rep.preventive': 'Vorbeugend (Ist)',
  'pm.rep.currencyMixed': 'Diese Auswahl umfasst mehrere Waehrungen. Die Summen werden ohne Umrechnung addiert — auf ein Werk bzw. einen Buchungskreis einschraenken, um eine vergleichbare Zahl zu erhalten.',
  'pm.rep.byType': 'Nach Auftragsart',
  'pm.rep.monthlyActual': 'Ist nach Monat',
  'pm.rep.topOrders': 'Teuerste Aufträge',
  'pm.rep.topEquipment': 'Teuerste Equipments',
  'pm.rep.orderType': 'Auftragsart',
  'pm.rep.order': 'Auftrag',
  'pm.rep.description': 'Bezeichnung',
  'pm.rep.totalHours': 'Rückgemeldete Stunden',
  'pm.rep.byWorkCenter': 'Nach Arbeitsplatz',
  'pm.rep.byMonth': 'Nach Monat',
  'pm.rep.workCenter': 'Arbeitsplatz',
  'pm.rep.hours': 'Stunden',
  'pm.rep.confirmations': 'Rückmeldungen',
  'pm.rep.totalValue': 'Verbrauchswert',
  'pm.rep.windowDays': 'Zeitraum (Tage)',
  'pm.rep.topMaterials': 'Top-Materialien',
  'pm.rep.material': 'Material',
  'pm.rep.qty': 'Menge',
  'pm.rep.unit': 'Einheit',
  'pm.rep.value': 'Wert',
  'pm.rep.breakdowns': 'Ausfälle',
  'pm.rep.mttrNote': 'MTTR wird aus den {n} von {total} Ausfällen berechnet, deren Störungsende erfasst wurde — beim Abschließen von Störmeldungen das Ende pflegen, um das zu verbessern.',
  'pm.rep.topByBreakdowns': 'Top-Equipments nach Ausfällen',
  'pm.rep.equipment': 'Equipment',
  'pm.rep.downtime': 'Ausfallzeit (h)',
  'pm.rep.completeWindows': 'Vollständige Datensätze',
  'pm.rep.plans': 'Wartungspläne',
  'pm.rep.openDueCalls': 'Fällig ohne Auftrag',
  'pm.rep.inactivePlans': 'Inaktive Pläne',
  'pm.rep.neverScheduled': 'Nie terminiert',
  'pm.rep.neverScheduledOne': 'nie terminiert',
  'pm.rep.perPlan': 'Je Plan',
  'pm.rep.plan': 'Plan',
  'pm.rep.calls': 'Abrufe',
  'pm.rep.withOrder': 'Mit Auftrag',
  'pm.rep.nextDue': 'Nächste Fälligkeit',
  'pm.rep.openDueN': '{n} fällig!',
  'pm.rep.onTrack': 'im Plan',
  'pm.rep.openOrdersK': 'Offene Aufträge',
  'pm.rep.breakdowns12m': 'Ausfälle (12 M)',
  'pm.rep.actualCostsYear': 'Ist-Kosten (Jahr)',
  'pm.rep.recentOrders': 'Aufträge an diesem Equipment',
  'pm.rep.recentNotifs': 'Meldungen zu diesem Equipment',

  // ── Real-Life-Paket 2026-08-10 ──
  'pm.scan.open': 'QR-Code scannen',
  'pm.scan.hint': 'Kamera auf das QR-Etikett an der Maschine richten.',
  'pm.avail.allCovered': 'Alle geplanten Teile sind auf Lager',
  'pm.avail.short': '{n} Teil(e) NICHT auf Lager',
  'pm.avail.needVsHave': 'benötigt {need}, verfügbar {have}',
  'pm.avail.releaseHint': 'Bei Freigabe jetzt kann die Arbeit auf Teile warten müssen.',
  'pm.assign.label': 'Zugewiesen an',
  'pm.assign.nobody': 'noch niemand',
  'pm.assign.placeholder': 'Benutzername…',
  'pm.assign.set': 'Zuweisen',
  'pm.assign.toMe': 'An mich',
  'pm.assign.recent': 'Zuletzt verwendet',
  'pm.assign.freeText': 'Kein passender Benutzer — „Zuweisen“ speichert den getippten Namen',
  // Sperr-Zustände (Server-/me-Feld `blocked`): Rolle ohne Werke / strict mode ohne Profil
  'pm.blocked.title': 'PM-Zugriff noch nicht eingerichtet',
  'pm.blocked.noPlants': 'Ihrer PM-Rolle ist noch kein Werk zugewiesen. Bitten Sie Ihren Administrator, in der Benutzerverwaltung Werke zuzuweisen.',
  'pm.blocked.noProfile': 'Der PM-Zugriff erfordert ein zugewiesenes PM-Profil. Bitten Sie Ihren Administrator, eines in der Benutzerverwaltung zuzuweisen.',
  'pm.photos.title': 'Fotos',
  'pm.photos.add': '+ Foto hinzufügen',
  'pm.photos.attached': 'Foto angehängt',
  'pm.photos.take': 'Foto vom Problem aufnehmen (optional)',
  // Ein verschluckter Upload-Fehler sieht genauso aus wie ein nicht geladenes Vorschaubild — der
  // Techniker geht weg und glaubt, das Foto sei da (Audit-Befund 05).
  'pm.photos.uploadFailed': 'Das Foto konnte nicht gespeichert werden — bitte erneut hinzufügen.',
  'pm.photos.tooLarge': 'Das Foto ist größer als 5 MB und wurde nicht gespeichert — bitte mit geringerer Auflösung neu aufnehmen.',
  'pm.codes.damageNone': 'Schadensbild (optional)…',
  'pm.codes.causeNone': 'Ursache (optional)…',
  'pm.notif.mlfnEndLabel': 'Wann war die Störung behoben? (speist die Zuverlässigkeitsberichte)',
  'pm.comp.prBridge': 'Von SAP für die Unterdeckung erzeugte Bestellanforderung — im Beschaffungsmodul zu finden',
  'pm.rep.pareto': 'Was kaputtgeht — und warum (Schadens-/Ursachen-Pareto)',
  'pm.rep.paretoEmpty': 'Noch keine Schadens-/Ursachencodes erfasst — im Melde-Wizard auswählen, dann füllt sich diese Auswertung von selbst.',
  'pm.rep.topDamages': 'Häufigste Schadensbilder',
  'pm.rep.topCauses': 'Häufigste Ursachen',
  'pm.rep.qrLabel': 'QR-Etikett',

  // Persönliches SAP-Konto (Nachvollziehbarkeit)
  'pm.sapacct.title': 'SAP-Konto',
  'pm.sapacct.statusOwn': 'Ihre SAP-Änderungen laufen unter Ihrem eigenen SAP-Benutzer {user} — SAP-Belege zeigen Ihren Namen.',
  'pm.sapacct.statusShared': 'Kein persönlicher SAP-Benutzer hinterlegt — Änderungen laufen über den gemeinsamen technischen Benutzer; Ihr Name wird trotzdem im Portal und im SAP-Aktivitätsprotokoll festgehalten.',
  'pm.sapacct.username': 'SAP-Benutzer (z. B. JSCHMIDT)',
  'pm.sapacct.password': 'SAP-Passwort',
  'pm.sapacct.save': 'Prüfen & speichern',
  'pm.sapacct.remove': 'Entfernen',
  'pm.sapacct.saved': 'Gegen SAP geprüft und gespeichert.',
  'pm.sapacct.removed': 'Entfernt — Änderungen laufen wieder über den technischen Benutzer.',
  'pm.sapacct.hint': 'Optional. Das Passwort wird vor dem Speichern gegen SAP geprüft, verschlüsselt abgelegt und nie wieder angezeigt. Ändert sich Ihr SAP-Passwort, hier neu speichern — ein veraltetes sperrt den SAP-Benutzer nach wenigen Versuchen.',
};

export default pm;
